import React from "react";
import { useCallback, useRef } from "react";

function useAuth() {
    // ----custome button function----


    const SwiperhandlePrev = useCallback((e) => {
        if (!e.current) return;
        e.current.swiper.slidePrev();
    }, []);

    const SwiperhandleNext = useCallback((e) => {
        if (!e.current) return;
        e.current.swiper.slideNext();
    }, []);

    // ----//custome button function----

    return { SwiperhandlePrev, SwiperhandleNext }
}

export default useAuth
